import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSwitch, FlexBox, Text } from '@dixa/lib-shared-habla';
import { useCallback, useMemo } from 'react';
import { useServerStorage } from 'utils/useServerStorage';
import styles from './toggleEmailAutofillForm.module.scss';
export const ToggleEmailAutofillFrom = () => {
    const { data, set } = useServerStorage('organization');
    const checked = !!data &&
        (data.autofill_email_from === undefined ||
            data.autofill_email_from === true);
    const onChange = useCallback((event) => {
        set({ autofill_email_from: () => event.target.checked });
    }, [set]);
    const input = useMemo(() => ({
        name: 'autofill_email_from',
        value: 'autofill_email_from',
        onChange,
        checked,
    }), [checked, onChange]);
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "300", className: styles.toggleBox }, { children: [_jsxs(FlexBox, Object.assign({ flex: "1", flexDirection: "column", gap: "200" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "1" }, { children: "Auto-fill the sender (From:) with the last selected value" })), _jsx(Text.Paragraph, Object.assign({ variant: "2" }, { children: "Apply to all agents but only for new outbound emails, not when replying in existing conversations. Each agent will have the last value they selected." }))] })), _jsx(FlexBox, Object.assign({ flex: "0" }, { children: _jsx(FieldSwitch, { input: input }) }))] })));
};
